'use strict';

export default function routes($stateProvider) 
{
	'ngInject';

	//console.log("Importing events_admin:routes");
	$stateProvider
		.state('myevents', {
			url: '/myevents',
			params: null,
			template: require('./myevents.html'),
			controller: 'MyEventsController',
			controllerAs: 'vm',
			authenticate: true
		})
		.state("eventedit", {
			url: "/ee", 
			params: {id: null},
			template: require("./event_edit.html"), 
			controller: "EventEditController",
			controllerAs: 'vm',
			authenticate: true 
		})
		.state("eventadd", {
			url: "/ea",
			params: null,
			template: require("./event_add.html"), 
			controller: "EventAddController",
			controllerAs: 'vm',
			authenticate: true 
		})
		.state("editinscriptions", { 
			url: "/ei", 
			params: {id: null}, 
			template: require("./edit_inscriptions.html"),
			controller: "EditInscriptionsController",
			controllerAs: "vm",
			authenticate: true 
		})
		.state("sendmessage", { 
			url: "/em", 
			params: {id: null}, 
			template: require("./send_message.html"),
			controller: "SendMessageController",
			controllerAs: "vm",
			authenticate: true 
		});
}

/*

.state('myevents', {
			url: '/myevents',
			params: null,
			//template: require('./myevents.html'),
			templateProvider: ['$q', function ($q) {
				console.log("2______ENSURE_____");
				let deferred = $q.defer();
				require.ensure(['./myevents.html'], function () {
					let template = require('./myevents.html');
					deferred.resolve(template);
				});
				return deferred.promise;
			}],
			controller: 'MyEventsController',
			controllerAs: 'vm',
			resolve: {
				foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
					console.log("1______RESOLVE_____");

					let deferred = $q.defer();
					require.ensure([], function () {
						
						let module = require('./page4/page4Module.js')(Angular);
						$ocLazyLoad.load({
							name: 'page4App'
						});
						deferred.resolve(module);
					});

					return deferred.promise;
				}]
			},
			authenticate: true
		})
 */


// WEBPACK FOOTER //
// ./client/app/backend/events/events.routes.js